import UserGroupsTable from './UserGroupsTable';
export default UserGroupsTable;